// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAbom1px2J_D2JE_1urwGLhbxt2sySLCF0",
  authDomain: "quiride-e0248.firebaseapp.com",
  projectId: "quiride-e0248",
  storageBucket: "quiride-e0248.firebasestorage.app",
  messagingSenderId: "994746711737",
  appId: "1:994746711737:web:78a6ff20cddf433db2a568",
  measurementId: "G-PRQFGLXN5V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);